import React, { forwardRef } from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

interface CustomPhoneInputProps {
    label: string;
    error?: string;
    required?: boolean;
    value: string;
    onChange: (value: string, country: any) => void;
    defaultCountry?: string;
    placeholder?: string;
    disabled?: boolean;
    inputProps?: any;
}

const CustomPhoneInput = forwardRef<HTMLDivElement, CustomPhoneInputProps>(
    (
        {
            label,
            error,
            required,
            value,
            onChange,
            defaultCountry = 'us',
            placeholder = '+1 (555) 000-0000',
            disabled = false,
            inputProps,
            ...props
        },
        ref
    ) => {
        const handleChange = (value: string, country: any) => {
            if (disabled) return;
            onChange(value, country);
        };

        const cleanedValue = (value || '')
            .replace(/undefined/g, '')
            .replace(/null/g, '');

        const inputId = React.useId();
        const errorId = `${inputId}-error`;

        return (
            <div className="com-input-grp" ref={ref}>
                <label className="form-label" htmlFor={inputId}>
                    {label}
                    {required && <sup className="label-star">*</sup>}
                </label>

                <div className="phone-code-select-wrap">
                    <PhoneInput
                        country={defaultCountry}
                        containerClass={`phone-code-select ${disabled ? 'disabled' : ''}`}
                        inputClass={`phone-code-input ${error ? 'is-invalid' : ''}`}
                        placeholder={placeholder}
                        disableInitialCountryGuess={false}
                        enableLongNumbers={false}
                        countryCodeEditable={false}
                        value={cleanedValue || undefined}
                        onChange={handleChange}
                        disabled={disabled}   // ⭐ important
                        inputProps={{
                            id: inputId,
                            'aria-invalid': !!error,
                            'aria-describedby': error ? errorId : undefined,
                            ...inputProps,
                        }}
                        {...props}
                    />
                </div>

                {error && <p id={errorId} className="valid-error" tabIndex={0} role="alert" aria-live="polite">{error}</p>}
            </div>
        );
    }
);



CustomPhoneInput.displayName = 'CustomPhoneInput';

export default CustomPhoneInput;